import { render } from "./SliderGallery.vue?vue&type=template&id=95a492d2&scoped=true"
import script from "./SliderGallery.vue?vue&type=script&lang=js"
export * from "./SliderGallery.vue?vue&type=script&lang=js"

import "./SliderGallery.vue?vue&type=style&index=0&id=95a492d2&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a492d2"]])

export default __exports__